import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { useAuth } from './hooks/useAuth'
import AppLayout from './components/AppLayout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import WeeklyUpdate from './pages/WeeklyUpdate'
import KalenderEvent from './pages/KalenderEvent'
import CategoryPage from './pages/CategoryPage'
import ProgramPage from './pages/ProgramPage'
import DivisiPage from './pages/DivisiPage'
import KanalVideo from './pages/KanalVideo'
import DirekturiKontak from './pages/DirekturiKontak'
import DirekturiKontakDetail from './pages/DirekturiKontakDetail'
import Search from './pages/Search'
import Tentang from './pages/Tentang'
import Bantuan from './pages/Bantuan'

function AuthGuard() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cerah-sage">
        <div className="w-8 h-8 border-[3px] border-cerah-teal border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  return <Outlet />
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected — all under /app/* with AppLayout */}
          <Route element={<AuthGuard />}>
            <Route element={<AppLayout />}>
              <Route path="/app/dashboard"            element={<Dashboard />} />
              <Route path="/app/weekly-update"        element={<WeeklyUpdate />} />
              <Route path="/app/kalender-event"       element={<KalenderEvent />} />
              <Route path="/app/category/:slug"       element={<CategoryPage />} />
              <Route path="/app/program/:slug"        element={<ProgramPage />} />
              <Route path="/app/divisi/:slug"         element={<DivisiPage />} />
              <Route path="/app/kanal-video"          element={<KanalVideo />} />
              <Route path="/app/direktori-kontak"     element={<DirekturiKontak />} />
              <Route path="/app/direktori-kontak/:id" element={<DirekturiKontakDetail />} />
              <Route path="/app/search"               element={<Search />} />
              <Route path="/app/tentang"              element={<Tentang />} />
              <Route path="/app/bantuan"              element={<Bantuan />} />
              <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
            </Route>
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}
